import styled, { css, keyframes } from 'styled-components';

/* Appear row animations */
const appearRowAnimationRed = keyframes`
  from {
    background: var(--red2);
  }
  to {
    background: initial;
  }
`;

const appearRowAnimationGreen = keyframes`
  from {
    background: var(--green1);
  }
  to {
    background: initial;
  }
`;

/* Striped row animations - end with stripe background color */
const appearRowAnimationRedStriped = keyframes`
  from {
    background: var(--red2);
  }
  to {
    background: var(--black1b);
  }
`;

const appearRowAnimationGreenStriped = keyframes`
  from {
    background: var(--green1);
  }
  to {
    background: var(--black1b);
  }
`;

/**
 * This row have animation green/red when it's first time rendered
 */
type IAppearParams = {
  $appearAnimationIgnorePeriod?: boolean;
  $noHoverEffect?: boolean;
  $stripes?: boolean;
  fontSize?: string;
};

const AppearAnimatedRow = styled.tr<IAppearParams>`
  ${({ onClick }) => (onClick ? 'cursor: pointer;' : '')}
  ${({ fontSize }) => (fontSize ? `font-size: ${fontSize};` : '')}

  ${props =>
    props.$noHoverEffect
      ? ''
      : `
      &:hover td {
        background: var(--primary7);
      }
    // border-left: 1px solid transparent;
    // &:hover {
      // background: var(--black1);
      // filter: brightness(120%);
      // border-left: 1px solid var(--white);
    // }
    // & td:first-child {
      // border-left: 1px solid transparent;
    // }
    // &:hover td:first-child {
      // border-left-color: var(--white);
    //}
  `}

  /* Apply animation via className */
  &.color-red {
    animation-duration: ${props =>
      props.$appearAnimationIgnorePeriod === true ? '0s' : '1s'};
    animation-name: ${appearRowAnimationRed};
  }
  &.color-green {
    animation-duration: ${props =>
      props.$appearAnimationIgnorePeriod === true ? '0s' : '1s'};
    animation-name: ${appearRowAnimationGreen};
  }

  /* Striped animations for even rows - end with stripe background color */
  ${props =>
    props.$stripes
      ? css`
          &:nth-child(even).color-red {
            animation-name: ${appearRowAnimationRedStriped};
          }
          &:nth-child(even).color-green {
            animation-name: ${appearRowAnimationGreenStriped};
          }
        `
      : ''}
`;

export default AppearAnimatedRow;
